import { render, staticRenderFns } from "./aboutProducts.vue?vue&type=template&id=dad91d4a&scoped=true&"
import script from "./aboutProducts.vue?vue&type=script&lang=js&"
export * from "./aboutProducts.vue?vue&type=script&lang=js&"
import style0 from "./aboutProducts.vue?vue&type=style&index=0&id=dad91d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad91d4a",
  null
  
)

export default component.exports